import { render } from "./CreateAzureStorageTable.vue?vue&type=template&id=739af20e&scoped=true"
import script from "./CreateAzureStorageTable.vue?vue&type=script&lang=js"
export * from "./CreateAzureStorageTable.vue?vue&type=script&lang=js"

import "./CreateAzureStorageTable.vue?vue&type=style&index=0&id=739af20e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-739af20e"]])

export default __exports__